<template>
  <div class="p-navi-item-link-for-sp-on-general">
    <a
      v-touch:tap
      :target="target"
      :href="url"
      class="p-navi-item-link-for-sp-on-general__link"
    >
      <i
        v-if="$slots.icon"
        class="p-navi-item-link-for-sp-on-general__link__icon"
      >
        <span
          v-if="hasNotification && !isGroupBudget"
          class="p-navi-item-link-for-sp-on-general__link__notification"
        >
          <TextLabelNewArrivalCount :count="formatNotificationCount" />
        </span>

        <slot name="icon">
          <IconBase
            :width="24"
            :height="24"
            view-box="0 0 24 24"
            :icon-color="iconColor"
          >
            <IconArrowRight />
          </IconBase>
        </slot>
      </i>
      <span class="p-navi-item-link-for-sp-on-general__link__text">
        {{ label }}
      </span>
    </a>
    <slot name="content"></slot>
  </div>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import TextLabelNewArrivalCount from "@/common/components/atoms/TextLabelNewArrivalCount.vue";
import commons from "@/common/store/modules/commons";
import { Options, Vue } from "vue-class-component";

@Options({
  name: "NaviItemLinkForSpOnGeneral",
  props: {
    url: { type: String, default: "/", required: true },
    label: { type: String, default: "リンク", required: true },
    iconColor: { type: String, default: "#000000" },
    notificationCount: { type: [Number, String, Boolean], default: false },
    target: { type: String, default: "_self" }
  },
  components: {
    IconBase,
    IconArrowRight,
    TextLabelNewArrivalCount
  }
})
export default class NaviItemLinkForSpOnGeneral extends Vue {
  url!: string;
  label!: string;
  iconColor!: string;
  notificationCount!: number | boolean | string;
  target!: string;
  get hasNotification() {
    if (this.notificationCount === "...") return true;
    const total = Number(this.notificationCount);
    return Number.isFinite(total) && total > 0;
  }

  get formatNotificationCount() {
    const notificationCount = this.notificationCount;
    if (notificationCount === "..." || typeof notificationCount === "number" || notificationCount === false) {
      return notificationCount;
    }
    return parseInt(notificationCount.toString(), 10);
  }
  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode;
  }
}
</script>

<style lang="scss" scoped>
.p-navi-item-link-for-sp-on-general {
  &__link {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: rem(12) rem(16);
    text-align: left;

    &__icon {
      display: block;
      line-height: 1;
      margin-right: rem(8);
      position: relative;
    }

    &__notification {
      position: absolute;
      right: rem(-3);
      top: rem(-5);
    }

    &__text {
      width: rem(192);
      overflow-wrap: break-word;
      font-size: rem(16);
      line-height: 1.6;
      flex-grow: 1;
      display: block;
      margin-bottom: rem(3);
      font-weight: bold;

      &--child {
        font-size: rem(14);
        font-weight: normal;
      }
    }

    &__arrow {
      line-height: 1;
    }
  }
}
</style>
